var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7392 15.7713H12.2993V12.3314L22.619 2.01172L26.0589 5.45161L15.7392 15.7713Z",
    stroke: "#555770",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0391 4.5918L23.479 8.03169",
    stroke: "#555770",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76541 23.6338H20.0992",
    stroke: "#555770",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76541 19.5664H20.0992",
    stroke: "#555770",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76562 15.5H9.36419",
    stroke: "#555770",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76562 7.36523L13.3879 7.36523",
    stroke: "#555770",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76562 11.4326H9.36419",
    stroke: "#555770",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9235 13.0018V26.9893C23.9235 27.2543 23.8183 27.5084 23.6309 27.6958C23.4435 27.8831 23.1894 27.9884 22.9244 27.9884H4.94051C4.67553 27.9884 4.42141 27.8831 4.23404 27.6958C4.04667 27.5084 3.94141 27.2543 3.94141 26.9893V4.00985C3.94141 3.74487 4.04667 3.49074 4.23404 3.30337C4.42141 3.116 4.67553 3.01074 4.94051 3.01074H15.9307",
    stroke: "#8F90A6",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkNote);
export default __webpack_public_path__ + "static/media/DarkNote.22575d1ab54ab35af3eb10527517927e.svg";
export { ForwardRef as ReactComponent };